$(->
  $('input#user_email').focus(->
    $('.email-conf').show()
  )
)
